// ================================
// Article Fallback Loader
// Supplements .fsfi and .fspa sections when Liquid's 50-article-per-page limit
// means not enough matching articles were found server-side.
// Fetches /blogs/[handle]?view=json-articles&page=N and appends matching cards.
// ================================

(function () {
  var NEEDED_FEATURED_IN = 2;
  var NEEDED_PRODUCT_ARTICLES = 3;

  var featuredIn = /** @type {HTMLElement | null} */ (document.querySelector('.fsfi[data-fallback-blog]'));
  var productArticles = /** @type {HTMLElement | null} */ (document.querySelector('.fspa[data-fallback-blog]'));

  if (!featuredIn && !productArticles) return;

  var tmplFsfc = /** @type {HTMLTemplateElement | null} */ (document.getElementById('tmpl-fsfc'));
  var tmplFspaItem = /** @type {HTMLTemplateElement | null} */ (document.getElementById('tmpl-fspa-item'));

  /**
   * @param {string} blogHandle
   * @param {number} page
   * @returns {Promise<{current_page: number, pages: number, articles: Array<{id: number, title: string, url: string, image_url: string | null, image_alt: string, product_ids: number[]}>} | null>}
   */
  function fetchBlogPage(blogHandle, page) {
    return fetch('/blogs/' + blogHandle + '?view=json-articles&page=' + page)
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () { return null; });
  }

  /**
   * @param {{ title: string, url: string, image_url: string | null, image_alt: string }} article
   * @returns {HTMLElement | null}
   */
  function buildFsfcCard(article) {
    if (!tmplFsfc) return null;
    var node = /** @type {DocumentFragment} */ (tmplFsfc.content.cloneNode(true));
    var card = /** @type {HTMLElement} */ (node.querySelector('.fsfc'));
    var link = /** @type {HTMLAnchorElement} */ (card.querySelector('.fsfc__link'));
    link.href = article.url;
    link.setAttribute('aria-label', article.title);
    var img = /** @type {HTMLImageElement} */ (card.querySelector('.fsfc__img'));
    if (article.image_url) {
      img.src = article.image_url;
      img.alt = article.image_alt || article.title;
    } else {
      img.remove();
    }
    var titleEl = card.querySelector('.fsfc__title');
    if (titleEl) titleEl.textContent = article.title;
    return card;
  }

  /**
   * @param {{ title: string, url: string, image_url: string | null, image_alt: string }} article
   * @param {number} index
   * @returns {HTMLElement | null}
   */
  function buildFspaItem(article, index) {
    if (!tmplFspaItem) return null;
    var node = /** @type {DocumentFragment} */ (tmplFspaItem.content.cloneNode(true));
    var item = /** @type {HTMLElement} */ (node.querySelector('.fspa__item'));
    item.classList.add('fsbj__col--' + index);
    var link = /** @type {HTMLAnchorElement} */ (item.querySelector('.fspa__link'));
    link.href = article.url;
    var img = /** @type {HTMLImageElement} */ (item.querySelector('.fspa__img'));
    if (article.image_url) {
      img.src = article.image_url;
      img.alt = article.image_alt || article.title;
    } else {
      var media = item.querySelector('.fspa__media');
      if (media) media.remove();
    }
    var titleEl = item.querySelector('.fspa__article-title');
    if (titleEl) titleEl.textContent = article.title;
    return item;
  }

  /**
   * @param {HTMLElement} section
   * @param {number} needed
   * @param {'featured-in' | 'product-articles'} type
   */
  function fillSection(section, needed, type) {
    var productId = parseInt(section.dataset.productId || '0', 10);
    var blogHandle = section.dataset.fallbackBlog || '';
    var currentCount = parseInt(section.dataset.currentCount || '0', 10);

    if (!productId || !blogHandle || currentCount >= needed) return;

    var grid = type === 'featured-in'
      ? /** @type {HTMLElement | null} */ (section.querySelector('.fsfc-grid'))
      : /** @type {HTMLElement | null} */ (section.querySelector('.fspa__grid'));

    if (!grid) return;

    // Collect IDs already rendered server-side to avoid duplicates
    var existingIds = new Set();
    grid.querySelectorAll('[data-article-id]').forEach(function (el) {
      var id = parseInt(/** @type {HTMLElement} */ (el).dataset.articleId || '0', 10);
      if (id) existingIds.add(id);
    });

    var page = 1;
    var pages = 1;

    function fetchNext() {
      if (currentCount >= needed || page > pages) {
        if (currentCount > 0) {
          revealSection(section, grid, currentCount, type);
        }
        return;
      }

      fetchBlogPage(blogHandle, page).then(function (data) {
        if (!data) {
          if (currentCount > 0) revealSection(section, grid, currentCount, type);
          return;
        }

        pages = data.pages;

        for (var i = 0; i < data.articles.length; i++) {
          if (currentCount >= needed) break;
          var article = data.articles[i];
          if (existingIds.has(article.id)) continue;
          var relevantIds = type === 'featured-in' ? article.project_product_ids : article.journal_product_ids;
          if (relevantIds.indexOf(productId) === -1) continue;

          var el = null;
          if (type === 'featured-in') {
            el = buildFsfcCard(article);
          } else {
            el = buildFspaItem(article, currentCount);
          }
          if (el) {
            el.dataset.articleId = String(article.id);
            existingIds.add(article.id);
            grid.appendChild(el);
            currentCount++;
          }
        }

        page++;
        fetchNext();
      });
    }

    fetchNext();
  }

  /**
   * @param {HTMLElement} section
   * @param {HTMLElement} grid
   * @param {number} count
   * @param {'featured-in' | 'product-articles'} type
   */
  function revealSection(section, grid, count, type) {
    if (type === 'featured-in') {
      grid.className = grid.className.replace(/fsfc-grid--count-\d+/g, '').trim();
      grid.classList.add('fsfc-grid--count-' + count);
    }

    section.removeAttribute('hidden');

    if (type === 'product-articles') {
      var swiperEl = /** @type {any} */ (section.querySelector('.js-product-articles'));
      if (swiperEl) {
        if (swiperEl.swiper) {
          swiperEl.swiper.update();
        } else if (typeof Swiper !== 'undefined') {
          // @ts-ignore — Swiper is loaded globally via CDN
          new Swiper(swiperEl, {
            slidesPerView: 'auto',
            freeMode: true,
            grabCursor: true,
            speed: 600,
            scrollbar: {
              el: swiperEl.querySelector('.swiper-scrollbar'),
              draggable: true,
            },
          });
        }
      }
    }
  }

  function init() {
    if (featuredIn) fillSection(featuredIn, NEEDED_FEATURED_IN, 'featured-in');
    if (productArticles) fillSection(productArticles, NEEDED_PRODUCT_ARTICLES, 'product-articles');
  }

  // Run after window load so Swiper instances are already initialized
  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init, { once: true });
  }
})();
